module.exports = __webpack_public_path__ + "media/educator_advisory_board/Michael_Kabbaz-c1ef947e.png";